<template>
    <!-- Começo modal do OrderServiceShow, nenhuma outra alteração no template -->
    <!-- Nenhuma rota ou action foi modificada -->
    <div class="overlay" v-if="windowModal" @click="closeModal">
        <div class="janela" @click.stop>
            <div class="close-event" @click="closeModal">X</div>
            <OrderServiceShow :id="this.idModal" :error="errors" :showErro="showError" @submit-obs="submitObs"/>
        </div>
    </div>
    <!-- Fim modal OrderServiceShow -->

    <painel-component :itens="itensOne">
        <div class="filter-position" v-if="btnFilter">
            <button-one icon="filter" class="btn-filter" @click="filterWindow"/>
        </div>

        <form class="mb-4 mt-5">
            <transition name="fade-in-top">
                <row-component v-if="filter">
                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Código:</label>
                        <input-component :type-input="'text'" v-model="formDate.code"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'">
                        <label>Status:</label>
                        <multiselect v-model="formDate.status" :searchable="true" :options="selectOrderService"
                                     :noResultsText="this.$store.state.var.selectNotSearch"/>
                    </row-col-component>

                    <row-col-component :class-row-col="'col-xxl-3 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12'"
                                       v-if="buttonCheck.access_to_all">
                        <label>Responsável:</label>
                        <Multiselect v-model="formDate.responsible_id" label="name" :options="selectUserList"
                                     :searchable="true" :noResultsText="this.$store.state.var.selectNotSearch">
                            <template v-slot:singlelabel="{ value }">
                                <div class="multiselect-single-label">
                                    <img class="character-label-icon" :src="value.icon" alt=""> {{ value.name }}
                                </div>
                            </template>

                            <template v-slot:option="{ option }">
                                <img class="character-option-icon" :src="option.icon" alt=""> {{ option.name }}
                            </template>
                        </Multiselect>
                    </row-col-component>

                    <row-col-component
                            :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-0 mt-xxl-4'">
                        <button-one class="mx-1" @submit="submit" :icon="'search'"/>
                        <button-float class="mx-1" :itens="itensTwo" v-if="buttonCheck.create"/>
                    </row-col-component>
                </row-component>
            </transition>
        </form>

        <loder-send-component :text-title="'Carregando'" v-if="showLoader"/>

        <div v-else>
            <row-component>
                <row-col-component
                        :class-row-col="'col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-end'">
                    <div class="toggle_preferences">
                        <button :class="{ 'bg-active': parseInt(cardTable) === 1 }" @click="toggleCard" type="button"
                                tooltip="Card">
                            <i class="window maximize outline icon"></i>
                        </button>
                        <button :class="{ 'bg-active': parseInt(cardTable) === 2 }" @click="toggleTable" type="button"
                                tooltip="Tabela">
                            <i class="align justify icon"></i>
                        </button>
                    </div>
                </row-col-component>
            </row-component>

            <row-component v-if="parseInt(cardTable) === 1">
                <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12 mt-4'"
                                   v-for="(data, index) in objectReturn.itens.data" :key="index">
                    <div class="card-container">
                        <div class="flag-status" :class="[{ 'bg-open': parseInt(data.status) === 1 },
                        { 'bg-progress': parseInt(data.status) === 2 },
                        { 'bg-finished': parseInt(data.status) === 3 },]">
                            {{ stringStatus(data.status) }}
                        </div>

                        <img v-if="data.responsible_photo" :src="data.responsible_photo" alt="">
                        <img v-else src="@/assets/img/avatar.png" alt="">

                        <h3>Código: {{ data.code }}</h3>
                        <p>Responsável: {{ data.responsible_name }}</p>

                        <div class="aux-row-3">
                            <div class="text"><i class="calendar icon"></i>{{ data.date_scheduling }}</div>
                            <div class="text"><i class="clock icon"></i>{{ data.time_scheduling }}</div>
                        </div>

                        <div class="responsible-task">
                            <h6> Criador:</h6>
                            <img v-if="data.creator_user_photo" alt="" :src="data.creator_user_photo"
                                 class="avatar__image_2">
                            <img v-else src="@/assets/img/avatar.png" alt="" class="avatar__image_2">
                            {{ data.creator_user_name }}
                        </div>

                        <div class="buttons">
                            <button tooltip="Editar" class="primary" v-if="buttonCheck.edit && data.status <= 2"
                                    @click="routeEdit(data.id)">
                                <i class="edit icon"></i>
                            </button>

                            <button tooltip="Ver" class="primary" v-if="buttonCheck.show"
                                    @click="loadPageItens(data.id)">
                                <i class="eye icon"></i>
                            </button>

                            <button tooltip="Iniciar" class="primary"
                                    v-if="buttonCheck.open && parseInt(data.status) === 1"
                                    @click="startOrderOfService(data.id)">
                                <i class="check icon"></i>
                            </button>

                            <button tooltip="Fechar" class="primary"
                                    v-if="buttonCheck.close && parseInt(data.status) === 2"
                                    @click="closeOrderOfService(data.id)">
                                <i class="close icon"></i>
                            </button>
                        </div>
                    </div>
                </row-col-component>
            </row-component>

            <table class="table table-striped" v-if="parseInt(cardTable) === 2">
                <thead>
                <tr>
                    <th scope="col" style="width: 5%">Código</th>
                    <th scope="col" style="width: 10%">Criador</th>
                    <th scope="col" style="width: 10%">Responsável</th>
                    <th scope="col" style="width: 10%">Data / Hora de Agendamento</th>
                    <th scope="col" style="width: 10%">Status</th>
                    <th scope="col" style="width: 10%"
                        v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.close || buttonCheck.open">
                        Ações
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in objectReturn.itens.data" :key="index">
                    <td data-label="Ano">{{ data.code }}</td>
                    <td data-label="Criador">
                        <img v-if="data.creator_user_photo" alt="" :src="data.creator_user_photo"
                             class="avatar__image_2">
                        <img v-else src="@/assets/img/avatar.png" alt="" class="avatar__image_2">
                        {{ data.creator_user_name }}
                    </td>
                    <td data-label="Responsável">
                        <img v-if="data.responsible_photo" alt="" :src="data.responsible_photo" class="avatar__image_2">
                        <img v-else src="@/assets/img/avatar.png" alt="" class="avatar__image_2">
                        {{ data.responsible_name }}
                    </td>
                    <td data-label="Data / Hora de Agendamento">
                        {{ data.date_scheduling }} / {{ data.time_scheduling }}
                    </td>
                    <td data-label="Status">{{ stringStatus(data.status) }}</td>
                    <td data-label="Ações"
                        v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.close || buttonCheck.open">
                        <button tooltip="Editar" class="btn btn-success mx-1 button-show"
                                v-if="(buttonCheck.edit && data.status <= 2)" @click="routeEdit(data.id)">
                            <i class="edit icon"></i>
                        </button>

                        <button tooltip="Ver" class="btn btn-secondary mx-1 button-show" v-if="buttonCheck.show"
                                @click="loadPageItens(data.id)">
                            <i class="eye icon"></i>
                        </button>

                        <button tooltip="Iniciar" class="btn btn-primary mx-1 button-show"
                                v-if="buttonCheck.open && parseInt(data.status) === 1"
                                @click="startOrderOfService(data.id)">
                            <i class="check icon"></i>
                        </button>

                        <button tooltip="Fechar" class="btn btn-danger mx-1 button-show"
                                v-if="buttonCheck.close && parseInt(data.status) === 2"
                                @click="closeOrderOfService(data.id)">
                            <i class="close icon"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <button-pagination :pagination="objectReturn.itens" :offset="3" @paginate="loadOrdersOfServices"/>
        </div>
    </painel-component>
</template>

<script>
import ButtonPagination from "@/components/buttons/ButtonPagination";
import PainelComponent from "@/components/dashboard/PainelComponent";
import ButtonOne from "@/components/buttons/ButtonOne";
import ButtonFloat from "@/components/buttons/ButtonFloat";
import InputComponent from "@/components/form/InputComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import LoderSendComponent from "@/components/LoderSendComponent";
import Multiselect from "@vueform/multiselect";

import OrderServiceShow from "@/views/show/OrderServiceShow";

import {useToast} from "vue-toastification";

const toast = useToast();

export default {
    name: "OrderServiceSearch",
    components: {
        ButtonPagination,
        PainelComponent,
        ButtonOne,
        ButtonFloat,
        InputComponent,
        RowComponent,
        RowColComponent,
        LoderSendComponent,
        Multiselect,
        OrderServiceShow
    },

    created() {
        this.$store.dispatch('updateNamePage', 'Ordem de Serviço')
        this.$store.dispatch('loadUserListSelect')
        this.loadOrdersOfServices(1)
        this.resizeWindow()
        this.checkACL()
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "list alternate"
            },

            itensTwo: {
                route: "/order-of-service/create",
                icon: "plus",
                name: ''
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false,
                close: false,
                open: false,
                access_to_all: false
            },

            formDate: {
                id: '',
                responsible_id: '',
                code: '',
                status: '',
            },

            formDateStart: {
                id: ''
            },

            formDateClose: {
                id: ''
            },

            idModal: '',
            windowModal: false,
            scroll: true,

            cardTable: '',
            preferences: {
                type: 10,
                preference: ''
            },

            filter: true,
            btnFilter: false,

            errors: [],
            showLoader: true,
            showError: false,
            searchSubmit: false,
        }
    },

    methods: {
        submit() {
            this.loadOrdersOfServices(1)
            this.searchSubmit = true;
        },

        filterWindow() {
            this.filter = !this.filter
        },

        resizeWindow() {
            if (window.innerWidth <= 991) {
                this.filter = false
                this.btnFilter = true
            } else {
                this.filter = true
                this.btnFilter = false
            }
        },

        routeEdit(id) {
            this.$router.push({name: 'order-of-service-edit', params: {id: id}})
        },

        toggleTable() {
            this.userPreferences(2)
            this.cardTable = 2
        },

        toggleCard() {
            this.userPreferences(1)
            this.cardTable = 1
        },

        userPreferences(preference) {
            this.preferences.preference = preference
            this.$store.dispatch('userPreferences', this.preferences)
        },

        // Começo script usado no modal OrderServiceShow
        loadPageItens(id) {
            this.idModal = id
            this.$store.dispatch('loadOrderOfService', this.idModal).then(() => {
                this.windowModal = true
            }).catch(() => {
                toast.error("Erro desconhecido !", {timeout: 2000});
            })
        },

        closeModal() {
            this.windowModal = false
        },

        submitObs(formDate) {
            this.$store.dispatch('storeOrderOfServiceObs', formDate)
                .then(() => {
                    this.showError = false
                    this.errors = []
                    this.closeModal()
                    this.loadOrdersOfServices(1)
                    toast.success('Observação criada com sucesso', {timeout: 2000});
                }).catch((r) => {
                this.showError = true;
                this.errors = r.response.data.errors;
                this.closeModal()
                this.loadOrdersOfServices(1)
                toast.error("Seu formulário contém erros verificar!", {timeout: 2000});
            })
        },
        // Fim script usado no modal OrderServiceShow

        loadOrdersOfServices(page) {
            this.showLoader = true
            if (!this.searchSubmit) {
                this.$store.dispatch('loadOrdersOfServices', {...this.params, page})
                    .then((r) => {
                        this.showLoader = false
                        this.cardTable = r.tableCard
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.itens.data.length === 0) {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 10000});
                            }
                        }
                    }).catch(() => {
                    this.showLoader = false
                    this.searchSubmit = false;
                });
            }
        },

        stringStatus(status) {
            if (parseInt(status) === 1)
                return 'Aberto'

            if (parseInt(status) === 2)
                return 'Em Andamento'

            if (parseInt(status) === 3)
                return 'Finalizado'
        },

        startOrderOfService(id) {
            this.formDateStart.id = id
            this.$store.dispatch('startOrderOfService', this.formDateStart).then(() => {
                toast.success("Ordem de serviço iniciada com sucesso", {timeout: 2000});
                this.loadOrdersOfServices(1)
            }).catch(() => {
                toast.error("Houve um erro, verificar!", {timeout: 2000});
            })
        },

        closeOrderOfService(id) {
            this.formDateClose.id = id
            this.$store.dispatch('closeOrderOfService', this.formDateClose).then(() => {
                toast.success("Ordem de serviço finalizada com sucesso", {timeout: 2000});
                this.loadOrdersOfServices(1)
            }).catch(() => {
                toast.error("Houve um erro, verificar!", {timeout: 2000});
            })
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 32)
                .then((r) => {
                    if (r.data.indexOf('order-of-service-search') !== -1) {
                        this.showLoader = false

                        if (r.data.indexOf('order-of-service-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('order-of-service-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('order-of-service-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('order-of-service-start') !== -1) {
                            this.buttonCheck.open = true
                        }

                        if (r.data.indexOf('order-of-service-close') !== -1) {
                            this.buttonCheck.close = true
                        }

                        if (r.data.indexOf('order-of-service-access-to-all') !== -1) {
                            this.buttonCheck.access_to_all = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },
    },

    computed: {
        selectUserList() {
            return this.$store.state.var.selectUserList
        },

        selectOrderService() {
            return this.$store.state.var.selectOrderService
        },

        objectReturn() {
            return this.$store.state.order_service.items
        },

        params() {
            return {
                page: this.objectReturn.current_page,
                responsible_id: this.formDate.responsible_id,
                code: this.formDate.code,
                status: this.formDate.status,
            }
        },
    },
}
</script>

<style scoped src="@/assets/css/table-resp.css"></style>
<style scoped>
.bg-active {
    background-color: #d67c1c !important;
}

.responsible-task h6 {
    font-size: 14px;
}

.aux-row-3 .text > i {
    color: #7e7e7e;
}

.bg-open {
    background-color: #2185d0;
}

.bg-progress {
    background-color: #16ab39;
}

.bg-finished {
    background-color: #b5cc18;
}

.toggle_preferences > button {
    border: 0;
    width: 45px;
    color: #fff;
    height: 45px;
    margin: 0 5px;
    padding-right: 4px;
    border-radius: 50%;
    background-color: #323232;
}

.button-show {
    width: 35px;
    height: 35px;
    font-size: 15px;
    border-radius: 50px;
    padding-left: 0.5rem;
}

.responsible-task .avatar__image_2 {
    width: 30px;
    height: 30px;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid #d67c1c;
}

.card-container {
    width: 350px;
    color: #2f3032;
    margin: 0 auto;
    max-width: 100%;
    overflow: hidden;
    padding-top: 20px;
    position: relative;
    text-align: center;
    background-color: #ffffff;
    border: solid 1px #ededed;
    box-shadow: 10px 10px 15px rgb(0 0 0 / 35%);
}

.card-container h3 {
    color: #424242;
    font-size: 14px;
    font-family: inherit;
    text-transform: uppercase;
}

.card-container > img {
    width: 90px;
    padding: 7px;
    height: 90px;
    margin-top: 25px;
    border-radius: 50%;
    margin-bottom: 10px;
    border: 1px solid #d67c1c;
}

.buttons {
    display: flex;
    min-height: 60px;
    border-top: 1px solid #ededed;
}

button.primary {
    width: 100%;
    height: 60px;
    color: #7e7e7e;
    padding: 5px 25px;
    background-color: #f5f5f5;
    border: 1px solid #fdfdfd;
}

.responsible-task {
    padding: 15px;
    min-height: 80px;
    text-align: left;
    border-top: 1px solid #ededed;
}

.flag-status {
    padding: 10px 20px;
    background-color: #d67c1c;
    position: absolute;
    top: 0;
    width: 100%;
}

.aux-row-3 {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-evenly;
    margin-top: 10px;
    margin-bottom: 15px;
}

.janela {
    width: 90%;
    height: 80vh;
    overflow-y: auto;
    background: white;
    z-index: 100;
    padding: 50px;
    position: absolute;
    box-shadow: 10px 10px 23px 0 rgb(204 204 204);
}

.overlay {
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    display: flex;
    height: 100vh;
    position: absolute;
    align-items: center;
    justify-content: center;
}

.close-event {
    top: 0;
    right: 0;
    color: black;
    cursor: pointer;
    margin: 10px 20px;
    font-size: 1.5rem;
    position: absolute;
}

@media (max-width: 991px) {
    .janela {
        box-shadow: none;
        padding: 50px 15px 0;
    }

    .overlay {
        position: fixed !important;
        background-color: rgb(0, 0, 0, 0.5);
    }
}
</style>